<template>
  <div class="chat-text" :style="`align-items: ${ message.aiRespFlag == 0 ? 'self-end' : 'self-start'}`">
    <div class="message-wrapper">
      <div class="conversation-message" :style="`background: ${message.aiRespFlag == 0 ? '#E5F2FB' : '#F5F5F5'}`">
        <i class="iconfont icon-icon_user_manua2 icon_tips"
          v-if="message.choiceWordsBizType && message.choiceWordsBizType==1"></i>
        <i class="iconfont icon-icon_insight2 icon_tips"
          v-if="message.choiceWordsBizType && message.choiceWordsBizType==2"></i>
        <i class="iconfont icon-icon_cha1 icon_tips"
          v-if="message.choiceWordsBizType && message.choiceWordsBizType==3"></i>
        <span class="'message-title" v-html="formattedText" v-if="linkText.length == 0"></span>
        <div class="message-title-container" v-if="linkText.length > 0">
          <span class="message-title" v-html="formattedText"></span>
          <span class="message-link-title" @click="onLinkTitleClick">
            {{ linkText }}
          </span>
        </div>
        <ChatMapItem :message="message" v-if="!isLoding" />
        <ChatIssueItem v-if="!isLoding" :questions="message && message.msgJsonContent.suggestQuesList || []"
          :isAnimation="message.isAnimation" @issueFinish="onIssueFinish" @resetSendQusition="onResetSendQusition" />
        <div style="display: flex; flex-direction: row; margin-top: 6px;"
          :style="`marginTop: ${ currentText.length > 0  ? '6px' : '0'}`" v-if="isLoding">
          <ChatLoading :size="20" />
          <span class="message-normal-title">{{ currentTextTips }}</span>
        </div>
      </div>
      <div class="ai_chatcontent_actions-container">
        <div class="ai_chatcontent_actions-container_left">

        </div>
        <div class="ai_chatcontent_actions-container_right"
          v-show="!isLoding && message.aiRespFlag != 0 && message.chatId >= 0 && type != 2">
          <el-tooltip effect="light" placement="top" :content="$t('chat_controls_refresh')">
            <div class="ai-icon" @click="(()=>{onControls(2)})" v-if="message.msgJsonContent.fromQuestion">
              <i class="iconfont icon-icon_spin" />
            </div>
          </el-tooltip>
          <el-tooltip effect="light" placement="top" :content="$t('chat_controls_copy')">
            <div class="ai-icon" @click="(()=>{onControls(1)})">
              <i class="iconfont icon-icon_copy" />
            </div>
          </el-tooltip>
          <el-tooltip effect="light" placement="top" :content="$t('chat_controls_map')">
            <div class="ai-icon" @click="(()=>{onControls(3)})">
              <i class="iconfont icon-icon_mindmap" />
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
const { t } = useI18n()
import ChatLoading from "@/components/PDFChatComponents/ChatLoading.vue"
import ChatIssueItem from "@/components/PDFChatComponents/ChatItem/ChatIssueItem.vue"
import ChatMapItem from "@/components/PDFChatComponents/ChatMapItem/ChatMapItem.vue"

import { type Message} from '@/data/chat/Message';
import { marked } from 'marked';

marked.setOptions({
  gfm: true,
  breaks: true,
})

let call = defineEmits(["updateContentHeight", "controls", "animationFinish", "resetSendQusition", "proBuy", "onLinkTitleClick"])

let currentTextTips = ref(t('chat_auto_generating'))
let currentText = ref("")
let linkText = ref("")
let isLoding = ref(true)
let currentIndex = 0
interface Props {
  message: Message // 内容结构体
  index: number
  type?: number // 2 代表ai 翻译
}
const props = defineProps<Props>()

watch(currentText, () => {
  call("updateContentHeight")
},{
  deep: true
});


watch(() => props.message, (newParams, oldParams) => {
  if (oldParams.chatId == -1 && newParams.chatId > 0) {
    updataContent()
  }
  if (props.message.msgJsonContent.text) {
    currentText.value = props.message.msgJsonContent.text ?? ""
    // isLoding.value = false
  }
  if (props.message.msgJsonContent.linkText) {
    linkText.value = props.message.msgJsonContent.linkText ?? ""
  }
},{
  deep: true
});

function onControls(index) {
  call("controls", {index: index, params: {text: props.message.msgJsonContent.text, fromQuestion: props.message.msgJsonContent.fromQuestion}, message: props.message, 
  subscriptIndex: props.index})
}

function onResetSendQusition(content) {
  call("resetSendQusition", content)
}

// 重新生成
function onLinkTitleClick() {
  call("onLinkTitleClick")
}

function onProBuy(index) {
  call("proBuy", index)
}

function onIssueFinish() {
  console.log("onIssueFinish===")
  call("updateContentHeight")
}

const formattedText = computed(() => {
  if (currentText.value && props.message.aiRespFlag != 0) {
    let result = marked(currentText.value)
    const styledHtmlContent = `
    <style>
      ol {
        padding-left: 20px;
        font-size: 14px;
      }
    </style>
    ${result}
  `;
    // // 处理标题（以 # 开头）
    // result = result.replace(/^#\s(.+)$/gm, '<h1>$1</h1>'); // 红色标题
    // result = result.replace(/^##\s(.+)$/gm, '<h2>$1</h2>'); // 蓝色标题
    // result = result.replace(/^###\s(.+)$/gm, '<h3>$1</h1>'); // 红色标题
    // result = result.replace(/^####\s(.+)$/gm, '<h4>$1</h2>'); // 蓝色标题
    // result = result.replace(/^#####\s(.+)$/gm, '<h5>$1</h1>'); // 红色标题
    // result = result.replace(/^######\s(.+)$/gm, '<h6>$1</h2>'); // 蓝色标题
    // // 处理加粗文本（用 ** 包裹）
    // result = result.replace(/\*\*(.+?)\*\*/g, '<strong style="color: #262626;">$1</strong>'); // 加粗文本
    // return result.replace(/\n/g, '<br>');
    return styledHtmlContent
  }
  return currentText.value
});

function updataContent() {
  if (props.message.msgJsonContent && props.message.msgJsonContent.text) {
    // let maxLength = props.message.msgJsonContent.text.length ?? 0 
    // let tempMessageText = props.message.msgJsonContent.text
    // console.log("updataContent",tempMessageText)
    // if (currentIndex < maxLength) {
    //   setTimeout(()=>{
    //     let subString = tempMessageText.slice(0,currentIndex + 1)
    //     currentText.value = subString
    //     currentIndex += 1
    //     updataContent()
    //   },20)
    // }else {
    //   isLoding.value = false
    //   call("animationFinish")
    // }
    // let tempMessageText = props.message.msgJsonContent.text
    // currentText.value = tempMessageText
  }
  // else if (props.message.chatId == -1){
  //   setTimeout(()=>{
  //     updataContent()
  //   }, 1000)
  // }
}

onMounted(()=>{
  if (props.message && props.message.msgContent) {
    if (!props.message.isAnimation) {
      currentText.value = props.message.msgJsonContent.text ?? ''
      linkText.value = props.message.msgJsonContent.linkText ?? ""
      isLoding.value = false
    }else {
      isLoding.value = true // 动画中
      // setTimeout(()=>{
      //   updataContent()
      // }, 3000)
      updataContent()
    }
  }
  call("updateContentHeight")
})

</script>

<style lang="less" scoped>
.chat-text {
  width: 100%;
  display: flex;
  flex-direction: column;
  .message-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 4px;
    margin-bottom: 4px;
    position: relative;
    max-width: 100%;
    .conversation-message {
      border-radius: 8px;
      padding: 10px 12px;
      border-radius: 8px;
      font-size: 14px;
      overflow-wrap: break-word;
      box-sizing: border-box;
      max-width: 100%;
      .icon_tips{
        margin-right: 5px;
        vertical-align: middle;
        padding-bottom: 2px;
        display: inline-block;
      }
      .message-title {
        color: #262626;
        font-size: 14px;
        max-width: 100%;
        line-height: 20px;
        .ul {
          list-style-position: inside; /* 将标记放在列表项内部 */
        }
      }
      .message-normal-title {
        color: #262626;
        font-size: 14px;
        line-height: 20px;
        margin-left: 6px;
      }
      .message-title-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        .message-title {
          color: #262626;
          font-size: 14px;
          max-width: 100%;
          line-height: 20px;
        }
        .message-link-title {
          color: var(--progress-bg-color);
          font-size: 14px;
          max-width: 100%;
          line-height: 19px;
          cursor: pointer;
          border-bottom: 1px solid transparent;

          &:hover {
            border-bottom: 1px solid var(--progress-bg-color);
          }
        }
      }
    }
    .ai_chatcontent_actions-container {
      display: flex;
      opacity: 1;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      user-select: none;
      white-space: nowrap;
      margin-top: 4px;
      .ai_chatcontent_actions-container_left {
        display: flex;
        flex-direction: row;
        gap: 4px;
      }
      .ai_chatcontent_actions-container_right {
        display: flex;
        flex-direction: row;
        gap: 4px;
        .ai-icon {
          cursor: pointer;
          padding: 2px 5px ;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover {
            background-color: #F2F2F2;
          }
          .icon-icon_spin {
            color: #595959;
            font-size: 20px;
          }
          .icon-icon_copy{
            color: #595959;
            font-size: 20px;
          }
          .icon-icon_mindmap {
            color: #595959;
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
